<bnd-modal
  [open]="open()"
  (closed)="onCancel()"
  [title]="title ? (title | translate) : ''"
  size="md"
>
  @if (open()) {
    @if (readOnlyMode && !files.value.length) {
      <p class="text-center text-gray-500">
        {{ 'DIALOG.DOCUMENTS.NO_FILE_AVAILABLE' | translate }}
      </p>
    } @else {
      <bnd-file-upload
        [formControl]="files"
        [accept]="accept"
        [hint]="hint"
        [maxFileSize]="maxFileSize"
        [maxFiles]="maxFilesAllowed"
        [readonly]="readOnlyMode"
        (filesAdded)="onFilesAdded($event)"
        (fileRemoved)="onFileRemoved($event)"
      />
    }
    @if (typeOptions.length && files.value.length) {
      <div
        role="group"
        class="mt-5 flex flex-col gap-3 rounded-lg bg-gray-50 p-4"
        aria-labelledby="ao-document-types-title"
      >
        <p
          id="ao-document-types-title"
          class="m-0 text-sm font-semibold text-gray-900"
        >
          {{ 'INPUTS.FILE.TYPE_TITLE' | translate }}
        </p>
        @for (item of files.value; track item.id) {
          @let typeControl = types.get(item.id);
          @if (typeControl) {
            <bnd-select
              [label]="item.name"
              [items]="typeOptions"
              [formControl]="typeControl"
              bindValue="value"
              bindLabel="label"
            />
          }
        }
      </div>
    }
  }
  <div
    modal-footer
    class="flex justify-end gap-4"
  >
    @if (!readOnlyMode) {
      <bnd-button
        type="button"
        (click)="onCancel()"
      >
        {{ 'DIALOG.BUTTON.CANCEL' | translate }}
      </bnd-button>
    }
    <bnd-button
      type="button"
      (click)="onConfirm()"
      [disabled]="!isFormValid()"
      [color]="'primary'"
    >
      {{ 'DIALOG.BUTTON.OK' | translate }}
    </bnd-button>
  </div>
</bnd-modal>
